
import {VUE_APP_API_AI_AGENTS_BASE_URL} from '../../config/index'

const baseUrl=() => {
  let  url =VUE_APP_API_AI_AGENTS_BASE_URL;

     return url;
  }




// Endpoints específicos
const getFilesEndpoint = () => 
  (window.chatwootConfig && window.chatwootConfig.aiAgentsFilesEndpoint) || 
  process.env.AI_AGENTS_FILES_ENDPOINT || 
  '/files';

const getListEndpoint = () => 
  (window.chatwootConfig && window.chatwootConfig.aiAgentsListEndpoint) || 
  process.env.AI_AGENTS_LIST_ENDPOINT || 
  '/';

const getCreateEndpoint = () => 
  (window.chatwootConfig && window.chatwootConfig.aiAgentsCreateEndpoint) || 
  process.env.AI_AGENTS_CREATE_ENDPOINT || 
  '/';

const getDeleteEndpoint = (agentId) => 
  (window.chatwootConfig && window.chatwootConfig.aiAgentsDeleteEndpoint) || 
  `${process.env.AI_AGENTS_DELETE_ENDPOINT || '/'}${agentId}`;

const getAuthHeaders = (chatwootApiAccessToken) => ({
  'Content-Type': 'application/json',
  // Asegúrate que el Lambda espera esta cabecera o la que corresponda para la autenticación.
  'X-Chatwoot-Api-Access-Token': chatwootApiAccessToken,
});

const accountIdFromRoute = () => {
  const isInsideAccountScopedURLs = window.location.pathname.includes('/app/accounts');
  if (isInsideAccountScopedURLs) {
    return window.location.pathname.split('/')[3];
  }
  return '';
}

export default {

  get(params) {
    return axios.get( `${baseUrl()}/accounts/${accountIdFromRoute()}/ai-manager/agents`,{
      params:params/*,
      headers: {
      'Content-Type': 'application/json',
        'access-token': "i66CKjC2rpqW4bPSJ5jR7Q",
        'token-type': "Bearer",
        'client': "dn1y9Tl4ykPOWeSmhKzIAg",
        'expiry': 1769963247,
        'uid': "jjvasquezcabos@gmail.com",
      }*/
    });
  },

  uploadFile(formData){
    
    return axios.post(`${baseUrl()}/accounts/${accountIdFromRoute()}/ai-manager/files`,formData/*,{
     
      headers: {
        'Content-Type': 'multipart/form-data',
        'x-filename': formData.get('file').name,
       'access-token': "KxqyoQW16XX3Imn9OZBiXA",
        'token-type': "Bearer",
        'client': "7oy0cu8Vf_F7PTcNz9ZF7A",
        'expiry': 1744386126,
        'uid': "jjvasquezcabos@gmail.com"
      }
    }*/);
  },
  // Obtener un AI Agent específico por ID
  fetchAgent: (agentId) => {
    return axios.get( `${baseUrl()}/accounts/${accountIdFromRoute()}/ai-manager/agents/${agentId}`/*,{
     
      headers: {
      'Content-Type': 'application/json',
        'access-token': "i66CKjC2rpqW4bPSJ5jR7Q",
        'token-type': "Bearer",
        'client': "dn1y9Tl4ykPOWeSmhKzIAg",
        'expiry': 1769963247,
        'uid': "jjvasquezcabos@gmail.com",
      }
    }*/);
  },

  // Eliminar un AI Agent
  deleteAgent: (agentId) => {
    return axios.delete(`${baseUrl()}/accounts/${accountIdFromRoute()}/ai-manager/agents/${agentId}`/*, {
      headers: {
       'Content-Type': 'application/json',
        'access-token': "i66CKjC2rpqW4bPSJ5jR7Q",
        'token-type': "Bearer",
        'client': "dn1y9Tl4ykPOWeSmhKzIAg",
        'expiry': 1769963247,
        'uid': "jjvasquezcabos@gmail.com",
        }
    }*/);
  },
/*
  uploadFile: (formData, chatwootApiAccessToken, onUploadProgress) => {
    const headers = { ...getAuthHeaders(chatwootApiAccessToken) };
    // FormData sets its own Content-Type with the boundary, so remove the JSON one.
    delete headers['Content-Type'];

    return axios.post(`${getLambdaBaseUrl()}${getFilesEndpoint()}`, formData, {
      headers: headers,
      onUploadProgress: progressEvent => {
        if (progressEvent.total) {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          if (onUploadProgress) {
            onUploadProgress(percentCompleted);
          }
        }
      },
    });
  },*/

  createAgent: (agentData) => {
    return axios.post(`${baseUrl()}/accounts/${accountIdFromRoute()}/ai-manager/agents`, agentData/*, {
      headers: {
        'Content-Type': 'application/json',
        'access-token': "i66CKjC2rpqW4bPSJ5jR7Q",
        'token-type': "Bearer",
        'client': "dn1y9Tl4ykPOWeSmhKzIAg",
        'expiry': 1769963247,
        'uid': "jjvasquezcabos@gmail.com",
      },
    }*/);
  },

  updateAgent: (agentData) => {
    return axios.patch(`${baseUrl()}/accounts/${accountIdFromRoute()}/ai-manager/agents/${agentData.id}`, agentData.payload/*, {
      headers: {
        'Content-Type': 'application/json',
        'access-token': "KxqyoQW16XX3Imn9OZBiXA",
        'token-type': "Bearer",
        'client': "7oy0cu8Vf_F7PTcNz9ZF7A",
        'expiry': 1744386126,
        'uid': "jjvasquezcabos@gmail.com",
      },
    }*/);
  },

  validateOpenAIApiKey: (apiKey, model) => {
    // This call goes directly to OpenAI, not through the Lambda
    const payload = {
      model: model,
      messages: [{ role: 'user', content: 'Hello' }],
      ...(['gpt-5', 'gpt-5-mini'].includes(model)
        ? { max_completion_tokens: 5 }
        : { max_tokens: 5 }
      )
    };
    return axios.post('https://api.openai.com/v1/chat/completions', payload, {
      headers: {
        'Authorization': `Bearer ${apiKey}`,
        'Content-Type': 'application/json',
      }
    });
  }
}; 